// extracted by mini-css-extract-plugin
module.exports = {"passwordWrapper":"page_passwordWrapper__I_DGm","logo":"page_logo__8tu6o"};